export const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const HEX_IDENTIFIER_PATTERN = /^[0-9a-f]{16,}$/i;
export const HEX_WITH_OPAQUE_SUFFIX_PATTERN =
  /^[0-9a-f]{16,}[-:][0-9a-zA-Z:$._-]+$/i;
export const NUMERIC_ID_PATTERN = /^\d+$/;
export const SHORT_HEX_IDENTIFIER_PATTERN =
  /^(?=.*[0-9])(?=.*[a-f])[0-9a-f]{4,}$/i;
export const MIXED_ALPHANUMERIC_OPAQUE_TOKEN_PATTERN =
  /^(?=.*[a-z])(?=.*[0-9])[a-z0-9]{8,21}$/;
const MIXED_OPAQUE_TOKEN_MAX_ALPHA_RUN = 5;

export function isMixedAlphanumericOpaqueToken(segment: string): boolean {
  if (!MIXED_ALPHANUMERIC_OPAQUE_TOKEN_PATTERN.test(segment)) {
    return false;
  }

  const alphaRuns = segment.match(/[a-z]+/g) ?? [];

  return alphaRuns.every(
    (run) => run.length <= MIXED_OPAQUE_TOKEN_MAX_ALPHA_RUN,
  );
}

export function decodePathSegment(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
